import styled from 'styled-components';
import { Flex } from 'UI';
import { CrossButton, CrossButtonProps } from 'UI/Button';

export const ExpandedContainer = styled(Flex)<{ $viewerOnly?: boolean }>`
  position: relative;
  width: 100%;
  min-height: 640px;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.grey90};
  box-shadow: 0 5px 12px 4px ${({ theme }) => theme.color.shadow_6}, 0 3px 6px 0 ${({ theme }) => theme.color.shadow_5},
    0 1px 2px -2px ${({ theme }) => theme.color.shadow_4};
  border-radius: 4px;
  padding: 48px 72px 40px 40px;
  gap: ${({ $viewerOnly }) => ($viewerOnly ? '0' : '44px')};

  @media (max-width: ${({ theme }) => theme.breakpoint.md}px) {
    flex-direction: column;
    padding: 32px 20px;
  }
`;

export const ExpandedGalleryColumn = styled.div<{ $viewerOnly?: boolean }>`
  flex: ${({ $viewerOnly }) => ($viewerOnly ? '1 1 100%' : '1 1 65%')};
  width: ${({ $viewerOnly }) => ($viewerOnly ? '100%' : 'auto')};
  min-width: 0;
`;

export const ExpandedInfoColumn = styled(Flex)`
  min-width: 280px;

  @media (max-width: ${({ theme }) => theme.breakpoint.md}px) {
    flex: 1 1 auto;
    width: 100%;
  }
`;

export const CloseButton = styled(CrossButton)<CrossButtonProps>`
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 4;
`;

export const OpenFullImageButton = styled.button`
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.color.clear_blue};
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;
